<div class="flex flex-col">
    <div class="flex flex-col justify-center sm:w-auto">
      <div class="mb-8 flex flex-col justify-center sm:w-auto">
        <div class="flex justify-center text-3xl sm:text-40px sm:font-rhetorik-sans mt-6">Your Favorites</div>
      </div>
    </div>
    <div *ngIf="favorites.length !== 0" class="flex justify-between items-baseline">
      <div id="prop-favorite-sort-div" class="text-gray-tricon"><span class="hidden sm:inline">Sort By: </span>
        <mat-form-field class="favorite-dropdown" appearance="fill">
          <mat-select class="favorite-sort"[(value)]="selectedOption" (selectionChange)="sortFavorites()">
            <mat-option *ngFor="let option of options" [value]="option.value">
            {{option.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <button *ngIf="!viewMap" class="mx-2 text-base relative bottom-m5" mat-button color="accent" (click)="toggleMap()">VIEW MAP</button>
      <button *ngIf="viewMap" class="mx-2 text-base relative bottom-m5" mat-button color="accent" (click)="toggleMap()">HIDE MAP</button>
    </div>
    <div class="sm:w-auto flex justify-center border-0">
      <div class="grid grid-cols-1 sm:grid-cols-3 sm:gap-8">
        <div *ngFor="let fav of favorites">
          <div *ngIf="fav.PropertyViewCard.sqft" class="my-4 flex justify-center flex-col max-w-500px">
            <div class="grid grid-cols-5fr-1fr grid-rows-1fr-4fr">
              <img [ngStyle]="{'filter': (fav.Leased) ? 'brightness(40%)': 'none'}" class="rounded w-full h-auto max-w-500px z-0 col-start-1 col-end-3 row-start-1 row-end-3" src={{fav.PropertyViewCard.thumb}}>
              <div class="col-start-2 col-end-3 z-20 row-start-1 row-end-2 self-center justify-self-center" (click)="toggleFavorite(fav)">
                <svg [ngClass]="{'favorite-heart-active': fav.Active,
                'favorite-heart-inactive': !fav.Active}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192">
                <path d="M100.2,158.9,161,98.1c14.9-14.9,17.2-39.5,3-55.2A39,39,0,0,0,108.9,40l-1.5,1.4L96,52.8,86.1,43C71.2,28.1,46.6,25.8,30.9,40A39,39,0,0,0,28,95.1l1.4,1.5,62.4,62.3A5.8,5.8,0,0,0,100.2,158.9Z"/>
                </svg></div>
                <div *ngIf="fav.BannerText" [ngClass]="{'bg-gray-tricon': !fav.Leased}" class="col-start-1 col-end-2 z-10 row-start-1 row-end-2 flex self-start justify-self-start  text-white py-1 px-3 rounded"><div>{{fav.BannerText}}</div></div>
            </div>
            <div class="flex flex-row justify-between items-baseline">
              <div class="flex text-2xl font-bold items-baseline">
                ${{fav.PropertyViewCard.rent}} <span class="text-base text-gray-tricon ml-1">/mo</span>
              </div>
              <div class="flex flex-row justify-evenly text-lg">
                <div class="flex text-black">{{fav.PropertyViewCard.beds}}<span class="text-gray-tricon mx-1">bd</span> <span class="text-gray-tricon">|</span></div>
                <div class="flex ml-1 text-black">{{fav.PropertyViewCard.baths}}<span class="text-gray-tricon mx-1">ba</span> <span class="text-gray-tricon"> |</span> </div>
                <div class="flex ml-1 text-black">{{fav.PropertyViewCard.sqft}}<span class="text-gray-tricon ml-1">sqft</span></div>
              </div>
            </div>
            <div class="text-lg sm:font-2xl flex flex-wrap">
              {{fav.PropertyViewCard.street}} {{fav.PropertyViewCard.region}} {{fav.PropertyViewCard.zip}}
            </div>
            <div class="h-10 flex items-center"><div class="text-base text-starburst-orange">{{fav.ConcessionText}}</div></div>
            <div *ngIf="!fav.Leased && showButtons" class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2 sm:mt-4">
              <button mat-flat-button color="accent" (click)="viewListing(fav)">VIEW LISTING</button>
              <button mat-flat-button color="primary"(click)="applyNow(fav)">APPLY NOW</button>
            </div>

          </div>
          <div *ngIf="!fav.PropertyViewCard.sqft" class="my-4 flex flex-col">
            <div >
              <img class="rounded w-full h-auto max-h-400px max-w-600px" src="../../../assets/images/FallbackImage_House.jpg">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sm:mt-16" *ngIf="viewMap">
      <app-map *ngIf="mapLocations.length > 0 || mfMapLocations.length > 0"class="flex" [mapLocations]="mapLocations" [mfMapLocations]="mfMapLocations"></app-map>
    </div>
  </div>
